// extracted by mini-css-extract-plugin
export default {"app_layout":"b_e_RMm","app_main":"b_f_JFx","container":"b_g_nxe","genre":"b_h_1Kw","genre_header":"b_i_4L6","genre_body":"b_j_MHO"};